//ToDo: refactor remove key func
export const removeKey = (obj: any, key: any): any =>
  obj !== Object(obj)
    ? obj
    : Array.isArray(obj)
    ? obj.map((item) => removeKey(item, key))
    : Object.keys(obj)
        .filter((k) => k !== key)
        .reduce((acc, x) => Object.assign(acc, { [x]: removeKey(obj[x], key) }), {});
